var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-alert',{staticClass:"email-phi-warning",attrs:{"type":"warning","title":"Voicemail emails may contain protected health information (PHI).","description":"Only send to email addresses secured for PHI.","closable":false,"show-icon":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }